export type DelistUiStep = 1 | 2 | 3;

export type DelistStepState = 'pending' | 'active' | 'success' | 'failed';

export type DelistJobProgress = {
  currentStep?: DelistUiStep | null;
  completedSteps?: DelistUiStep[];
  failedStep?: DelistUiStep | null;
  message?: string;
};

export const DELIST_UI_STEPS: Array<{ id: DelistUiStep; label: (ticketLabel: string) => string }> = [
  {
    id: 1,
    label: () => 'Unshare, set price to 1¢, and append "." to the row',
  },
  {
    id: 2,
    label: () => 'Unlist those tickets from Victory Live',
  },
  {
    id: 3,
    label: (ticketLabel) => `Move ${ticketLabel} to Delisted in QuickAsyst`,
  },
];

export function delistStepState(
  step: DelistUiStep,
  progress: DelistJobProgress | null | undefined,
  running: boolean,
): DelistStepState {
  const completed = progress?.completedSteps || [];
  if (completed.includes(step)) return 'success';
  if (progress?.failedStep === step) return 'failed';
  if (running && progress?.currentStep === step) return 'active';
  return 'pending';
}
